import React, { useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Container, Row, Card, Form } from "react-bootstrap";

import logo from "assets/imgs/Logo-Principal-Brancopng.png";

import { POST_REPORT_ERRO } from "services/ReporteErro";

import { useAlert } from "context/AlertContext";
import { Context } from "context/AuthContext";

import "./styles.scss";

const ContentReporteErro = () => {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { showLoader } = useContext(Context);
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    descricao: "",
    imagem: null,
  });

  // Manipulador para alterações no formulário
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Manipulador para upload de arquivo
  const handleFileChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      imagem: e.target.files[0],
    }));
  };

  const validate = () => {
    let errors = [];
    if (!formData.nome) {
      errors.push("O campo nome é obrigatório");
    }

    if (!formData.email) {
      errors.push("O campo email é obrigatório");
    }

    if (!formData.descricao) {
      errors.push("O campo descrição é obrigatório");
    }
    return errors;
  };

  // Manipulador de envio do formulário
  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (validationErrors.length > 0) {
      showAlert(validationErrors, "danger");
      return;
    }
    showLoader(true);
    // Cria um objeto com os dados do formulário
    const reporteErro = {
      nomeUsuario: formData.nome,
      emailUsuario: formData.email,
      descricaoErro: formData.descricao,
      anexos: formData.imagem ? [formData.imagem] : [],
    };

    // Envia o formulário
    POST_REPORT_ERRO(reporteErro).then((response) => {
      if (response) {
        showAlert(response.message, "success");
        setFormData({
          nome: "",
          email: "",
          descricao: "",
          imagem: null,
        });

        // Limpa o input de arquivo
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        showLoader(false);
      } else {
        showAlert(response.message, "danger");
        showLoader(false);
      }
    });
  };

  return (
    <div className="report-wrapper">
      <Container fluid>
        <Row className="vh-100 d-flex justify-content-center align-items-center content-report">
          <Col md={8} lg={10} xs={12}>
            <Card className="shadow">
              <Row className="g-0 h-150">
                <Col md={4} className="column-img-report ">
                  <img
                    src={logo}
                    alt="Imagem de registro"
                    className="img-fluid card-img"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body className="h-100 d-flex flex-column m-3">
                    <div className="mb-3 mt-4">
                      <h3 className="fw-bold mb-2">Encontrou algum erro?</h3>
                      <p className="mb-5">
                        Conte-nos o que aconteceu para que possamos corrigir o
                        mais rápido possível.
                      </p>
                      <Form
                        className="flex-grow-1 d-flex flex-column justify-content-between"
                        onSubmit={handleSubmit}
                      >
                        <div>
                          <Row className="mb-3">
                            <Form.Group
                              as={Col}
                              className="mb-3"
                              controlId="formBasicPassword"
                            >
                              <Form.Label>Nome</Form.Label>
                              <Form.Control
                                type="text"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}
                              />

                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                              />

                              {/* <Form.Label>Assunto</Form.Label>
                              <Form.Control
                                type="text"
                                name="assunto"
                                value={formData.assunto}
                                onChange={handleChange}
                              /> */}

                              <Form.Label>Descrição</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                name="descricao"
                                placeholder="Descreva o erro encontrado"
                                value={formData.descricao}
                                onChange={handleChange}
                              />

                              <Form.Label>Imagem (opcional)</Form.Label>
                              <Form.Control
                                type="file"
                                name="imagem"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                              />
                            </Form.Group>
                          </Row>
                        </div>

                        <div className="d-flex justify-content-between gap-3">
                          <Button
                            variant="primary"
                            type="button"
                            onClick={() => navigate("/")}
                          >
                            <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                          </Button>
                          <Button variant="primary" type="submit">
                            Enviar
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContentReporteErro;
